// vendor modules
import React, { Component } from "react"
import PropTypes from "prop-types"

import PlatformSpecificFilterSet from "app/static/frontend/search-new/containers/FilterSet"

export default class FilterSet extends Component {
    static propTypes = {
        // default filter logic
        hasDefaultFilters: PropTypes.bool.isRequired,
        allDefaultFiltersActive: PropTypes.bool,
        nonDefaultFiltersActive: PropTypes.bool,
        applyDefaultSearchFilters: PropTypes.func.isRequired,
        // menu actions
        closeAllFilterGroups: PropTypes.func.isRequired,
        resetFilters: PropTypes.func.isRequired,
        resetDefaultFilters: PropTypes.func.isRequired,
        uniqueFlvId: PropTypes.string,
        searchPlaceholderText: PropTypes.string,
        // searchify
        isSearchifySubmittable: PropTypes.bool,
        searchifyHeaderName: PropTypes.string,
        // filter groups
        filterGroups: PropTypes.arrayOf(PropTypes.func).isRequired,
        permissionedFilterGroups: PropTypes.arrayOf(PropTypes.func.isRequired),
        // ai search
        setAiSearchApplied: PropTypes.func,
    }

    static defaultProps = {
        isSearchifySubmittable: false,
    }

    constructor(props) {
        super(props)

        this.resetFilters = this.resetFilters.bind(this)
        this.resetDefaultFilters = this.resetDefaultFilters.bind(this)
        this.clearAndApplyDefaultFilters = this.clearAndApplyDefaultFilters.bind(this)
    }

    /** ***************************************************************************
     * Default Filters Logic
     ***************************************************************************** */
    resetFilters(callback) {
        this.props.resetFilters(this.props.uniqueFlvId)
        // reset ai search applied when clearing filters
        this.props.setAiSearchApplied({ isApplied: false, filterKeys: {} })
        // callbacks for mobile app, which will collapse any open filter
        if (typeof callback === "function") {
            callback()
        }
    }

    resetDefaultFilters(callback) {
        // can't just call resetFilters because we run into some weird stuff with
        // protected searches (advanced_search, for instance, doesn't usually
        // get cleared)
        this.props.resetDefaultFilters(this.props.uniqueFlvId)
        // callbacks for mobile app, which will collapse any open filter
        if (typeof callback === "function") {
            callback()
        }
    }

    clearAndApplyDefaultFilters(callback) {
        this.resetFilters(callback)
        this.props.applyDefaultSearchFilters(this.props.uniqueFlvId)
    }

    getFilterGlobalButtonDetails() {
        let onPressFunc = this.resetFilters
        let footerButtonText = "Clear Filters"

        if (this.props.hasDefaultFilters) {
            if (this.props.nonDefaultFiltersActive) {
                // if non-default filters are active (so something non-default is happening),
                // just display 'clear filters'. When 'clear filters' is pushed,
                // all filters are cleared and default filters are applied.
                onPressFunc = this.clearAndApplyDefaultFilters
            } else if (this.props.allDefaultFiltersActive && !this.props.nonDefaultFiltersActive) {
                // if the default filters are active but there are no other active filters,
                // display the option to clear default filters. This will reset all filters
                // to undefined.
                onPressFunc = this.resetDefaultFilters
                footerButtonText = "Clear Default Filters"
            } else if (!this.props.allDefaultFiltersActive && !this.props.nonDefaultFiltersActive) {
                // if the default filters are not active and no non-default filters are active,
                // allow ability to apply filters.
                onPressFunc = () => this.props.applyDefaultSearchFilters(this.props.uniqueFlvId)
                footerButtonText = "Apply Default Filters"
            }
        }

        return { onPress: onPressFunc, text: footerButtonText }
    }

    /** ***************************************************************************
     * Render logic!
     ***************************************************************************** */
    render() {
        return (
            <PlatformSpecificFilterSet
                {...this.props}
                filterGlobalButtonDetails={this.getFilterGlobalButtonDetails()}
                filterGroups={this.props.permissionedFilterGroups}
            />
        )
    }
}
